export class PreviousEnrollment {
  admissionYear: string = '';
  lastUpdate: string = '';
  lastYearOfStudy: string = '';
  namesUsed: string = '';
  personId: string = '';
  previousEnrollment: string = '';
  previousEnrollmentId: string = '';
  programmeOfStudy: string = '';
  reasonsForLeaving: string = '';
  residencyName: string = '';
  universityName: string = '';
}